import { render, staticRenderFns } from "./organization-list.vue?vue&type=template&id=71f4e5d7&"
import script from "./organization-list.vue?vue&type=script&lang=js&"
export * from "./organization-list.vue?vue&type=script&lang=js&"
import style0 from "./organization-list.vue?vue&type=style&index=0&id=71f4e5d7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports